import { create } from 'zustand';

interface UiState {
  chatOpen: boolean;
  leaderboardOpen: boolean;
  setChatOpen: (open: boolean) => void;
  setLeaderboardOpen: (open: boolean) => void;
}

export const useUiStore = create<UiState>((set) => ({
  chatOpen: false,
  leaderboardOpen: false,
  setChatOpen: (open) => set({ chatOpen: open }),
  setLeaderboardOpen: (open) => set({ leaderboardOpen: open }),
}));
